import React from 'react';
import { objectiveIcons } from '@bbkAdminUtils/icons/objective-icons';
import { type PlayType } from '@bbkAdminRedux/rtkq/play.slice';
import { type OfferObjective } from '@bbkAdminUtils/api-client/rest-offers-api';
import { cs } from '@bbkAdminUtils/css-utils';

export type CardData = {
  id: number;
  title: string;
  subtitle: string;
  image: React.ReactNode;
  value:
    | 'ACQUISITION'
    | 'UPSELL'
    | 'CHURN_PREVENTION'
    | 'CHURN_DEFLECT'
    | 'RETENTION';
};

export const PLAY_OBJECTIVES: CardData[] = [
  {
    id: 1,
    title: 'Acquisition',
    value: 'ACQUISITION',
    subtitle: 'I want to attract and convert new customers.',
    image: (
      <div
        className={cs(
          'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full',
          'tw-border-[1.5px] tw-border-cbrdanger-200 tw-bg-cbrdanger-100/80',
          '[&_img]:tw-h-8 [&_img]:tw-w-8'
        )}
      >
        {objectiveIcons.acquisition_png}
      </div>
    ),
  },
  {
    id: 2,
    title: 'Expansion',
    value: 'UPSELL',
    subtitle:
      'I want to upsell higher value products & services to existing subscribers.',
    image: (
      <div
        className={cs(
          'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full',
          'tw-border-[1.5px] tw-border-cbrprimary-300 tw-bg-cbrprimary-100/80',
          '[&_img]:tw-h-8 [&_img]:tw-w-8'
        )}
      >
        {objectiveIcons.expansion_png}
      </div>
    ),
  },
  {
    id: 3,
    title: 'Churn prevention',
    value: 'CHURN_PREVENTION',
    subtitle: 'I want to prevent my at-risk subscribers from churning.',
    image: (
      <div
        className={cs(
          'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full',
          'tw-border-[1.5px] tw-border-cbrsuccess-200 tw-bg-cbrsuccess-100/80',
          '[&_img]:tw-h-8 [&_img]:tw-w-8'
        )}
      >
        {objectiveIcons.retention_png}
      </div>
    ),
  },
  {
    id: 4,
    title: 'Churn deflection',
    value: 'CHURN_DEFLECT',
    subtitle:
      'I want to deflect my subscribers at the moment of cancellation with offers.',
    image: (
      <div
        className={cs(
          'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full',
          'tw-border-[1.5px] tw-border-cbrwarn-200 tw-bg-cbrwarn-100/80',
          '[&_img]:tw-h-8 [&_img]:tw-w-8'
        )}
      >
        {objectiveIcons.deflect_png}
      </div>
    ),
  },
  {
    id: 5,
    title: 'Retention',
    value: 'RETENTION',
    subtitle: 'I want to prevent my at-risk subscribers from churning.',
    image: (
      <div
        className={cs(
          'tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full',
          'tw-border-[1.5px] tw-border-cbrsuccess-200 tw-bg-cbrsuccess-100/80',
          '[&_img]:tw-h-8 [&_img]:tw-w-8'
        )}
      >
        {objectiveIcons.retention_png}
      </div>
    ),
  },
];

export const getObjectives = (
  objectivesToInclude: PlayType[] | OfferObjective[]
) =>
  PLAY_OBJECTIVES.filter((objective) =>
    objectivesToInclude.includes(objective.value)
  );
